module.exports = __webpack_public_path__ + "static/media/verified.ffa13b6b.svg";